import * as types from './constants'

const initialState = {
    plans: [],
    loadingPlans: true,
    plansError: null,

    plan: {},
    loadingPlan: true,
    planError: null,

    planComments: [],
    loadingPlanComments: false,
    planCommentsError: false,

    planFabrics: [],
    loadingPlanFabrics: false,
    planFabricsError: false,

    planProfile: {},
    planProfileLoading: false,
    planProfileError: null,

    planFilters: [],
    planFiltersLoading: false,
    planFiltersError: null,

    addingComment: false,
}

const reducer = (state = initialState, actions) => {
    switch (actions.type) {
        case types.GET_PLANS_START:
            return {
                ...state,
                loadingPlans: true,
                plansError: null,
            }
        case types.GET_PLANS_SUCCESS:
            return {
                ...state,
                plans: actions.payload,
                loadingPlans: false,
            }
        case types.GET_PLANS_FAIL:
            return {
                ...state,
                plansError: actions.payload,
                loadingPlans: false,
            }
        case types.RESET_PLANS:
            return {
                ...state,
                plans: [],
                loadingPlans: true,
                plansError: null,
            }
        case types.GET_PLAN_START:
            return {
                ...state,
                loadingPlan: true,
                planError: null,
            }
        case types.GET_PLAN_SUCCESS:
            return {
                ...state,
                plan: actions.payload,
                loadingPlan: false,
            }
        case types.GET_PLAN_FAIL:
            return {
                ...state,
                planError: actions.error,
                loadingPlan: false,
            }

        case types.GET_PLAN_COMMENTS_START:
            return {
                ...state,
                loadingPlanComments: true,
                planCommentsError: null,
            }
        case types.GET_PLAN_COMMENTS_SUCCESS:
            return {
                ...state,
                planComments: actions.payload,
                loadingPlanComments: false,
            }
        case types.GET_PLAN_COMMENTS_FAIL:
            return {
                ...state,
                planCommentsError: actions.error,
                loadingPlanComments: false,
            }
        case types.GET_PLAN_FABRICS_START:
            return {
                ...state,
                loadingPlanFabrics: true,
                planFabricsError: null,
            }
        case types.GET_PLAN_FABRICS_SUCCESS:
            return {
                ...state,
                planFabrics: actions.payload,
                loadingPlanFabrics: false,
            }
        case types.GET_PLAN_FABRICS_FAIL:
            return {
                ...state,
                planFabricsError: actions.error,
                loadingPlanFabrics: false,
            }

        case types.GET_PLAN_PROFILE_START:
            return {
                ...state,
                planProfileLoading: true,
                profileError: null,
            }
        case types.GET_PLAN_PROFILE_SUCCESS:
            return {
                ...state,
                planProfile: actions.payload,
                planProfileLoading: false,
            }
        case types.GET_PLAN_PROFILE_FAIL:
            return {
                ...state,
                profileError: actions.error,
                planProfileLoading: false,
                // TODO: TEMP
                // planProfile: null,
            }
        case types.GET_PLAN_FILTERS_START:
            return {
                ...state,
                planFiltersLoading: true,
                planFiltersError: null,
            }
        case types.GET_PLAN_FILTERS_SUCCESS:
            return {
                ...state,
                planFilters: actions.payload,
                planFiltersLoading: false,
            }
        case types.GET_PLAN_FILTERS_FAIL:
            return {
                ...state,
                planFiltersError: actions.error,
                planFiltersLoading: false,
            }
        case types.UPDATE_PLAN:
            return {
                ...state,
                plan: actions.payload,
            }
        case types.ADD_COMMENT_START:
            return {
                ...state,
                addingComment: true,
            }
        case types.ADD_COMMENT_SUCCESS:
            return {
                ...state,
                addingComment: false,
            }
        case types.ADD_COMMENT_FAIL:
            return {
                ...state,
                addingComment: false,
            }

        default:
            return state
    }
}

export default reducer
